import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { EmergencyManager } from './types';

export function useEmergencyManagerData(): Page<EmergencyManager> {
  return useCurrentPage<Page<EmergencyManager>>();
}
